import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Checkbox,
} from '@features/ui';
import { TPackages } from '@src/types';
import { FC, useCallback, useMemo } from 'react';
import { formatCurrency } from '@lib/utils.ts';

interface AddonsCardProps {
  selectedPackage?: TPackages;
  selectedAddons: number[];
  onSelectedAddons: (addons: number[]) => void;
}
export const AddonsCard: FC<AddonsCardProps> = ({
  selectedPackage,
  selectedAddons,
  onSelectedAddons,
}) => {
  const handleCheckedChange = useCallback(
    (checked: boolean, id: number) => {
      if (!checked) {
        onSelectedAddons(selectedAddons.filter((item) => item !== id));

        return;
      }
      onSelectedAddons([...selectedAddons, id]);
    },
    [onSelectedAddons, selectedAddons]
  );

  const addons = useMemo(
    () =>
      selectedPackage?.addons?.sort((a, b) => {
        const aProductId = Number(a?.id);
        const bProductId = Number(b?.id);

        if (aProductId > bProductId) {
          return 1;
        }
        if (aProductId < bProductId) {
          return -1;
        }

        return 0;
      }),
    [selectedPackage?.addons]
  );

  return (
    <Card className="bg-card py-10 px-1 justify-between w-full lg:w-1/3">
      <div>
        <CardHeader className="px-0 border-b pb-6">
          <CardTitle className="text-2xl text-center">
            Available Addons
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4 lg:space-y-[54px] pt-[21px] pl-[30px] pr-[20px]">
          {addons?.map((item) => {
            const specialPromo = item.display_name_web === 'Unlock Level 8';

            return (
              <div key={item.id} className="flex justify-between gap-3">
                <div className={'flex items-center gap-3 relative'}>
                  <Checkbox
                    checked={selectedAddons.includes(item.id)}
                    className="size-6 border-2 border-white"
                    id={`addon-${item.id}`}
                    onCheckedChange={(checked: boolean) =>
                      handleCheckedChange(checked, item.id)
                    }
                  />
                  <label className="font-medium text-lg" htmlFor="level8">
                    {item.display_name_web}{' '}
                    {specialPromo ? (
                      <span
                        className={
                          'text-lg font-medium bg-[linear-gradient(90deg,_#0350A8_22.87%,_#C3393A_92.65%)] bg-clip-text text-transparent'
                        }
                      >
                        Special Promo
                      </span>
                    ) : null}
                  </label>
                </div>
                <p className={'text-lg font-semibold'}>
                  ${formatCurrency(item.price ?? 0)}
                </p>
              </div>
            );
          })}
        </CardContent>
      </div>
    </Card>
  );
};
